module.exports = __webpack_public_path__ + "static/img/exhibitImage2.c482c904.jpg";